import { createAsyncThunk } from '@reduxjs/toolkit';
import ReportListingService from 'services/report-listing.service';
import {
  SidebarActionTypes,
} from './sidebar-store.state';

export const getTagsByUser = createAsyncThunk(SidebarActionTypes.GET_TAGS_BY_USER_REQUEST, async (profileId: string) => new ReportListingService().getTagsByUser(profileId));
export const getAllTags = createAsyncThunk(SidebarActionTypes.GET_ALL_TAGS_REQUEST, async () => new ReportListingService().getAllTags());
